import React, { Fragment } from "react";
import HomeComponent from "./components/home-component/HomeComponent";
import { FeaturesHomePageProps } from "./HomePageProps";
import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";

const StyledHomePageContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
});

const StyledSpacer = styled(Box)(({ theme }) => ({
    height: 60,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        height: 40,
    },
}));

const Spacer = () => <StyledSpacer className="kms-ds-homepage-component-spacer" />;

export function HomePage({ components = [] }: FeaturesHomePageProps) {
    /* If page contains only one component and it is not a hero component,
       or if there are multiple components, add bottom spacer element.
       Hero components are always at the top and do not require a spacer below if it is a single component in page.
    */
    const shouldAddBottomSpacerElement = !!components.length && !components[components.length - 1].isHero;

    return (
        <StyledHomePageContainer className="kms-ds-homepage">
            {components.map((component, index) => (
                <Fragment key={index}>
                    {/* Add spacer element above the first component if it's not a hero component.
                        Hero components stick to the header and do not need a top spacer.
                        Hero component, if present, will always be the first component in the array.
                     */}
                    {index === 0 && !component.isHero && <Spacer />}
                    {/* Add a spacer element above any subsequent components */}
                    {index > 0 && <Spacer />}
                    <HomeComponent {...component} />
                </Fragment>
            ))}
            {shouldAddBottomSpacerElement && <Spacer />}
        </StyledHomePageContainer>
    );
}

export default HomePage;
